// extracted by mini-css-extract-plugin
export default {"mydisabled":"StepSingleRoom_mydisabled__Z3+j9","occupied":"StepSingleRoom_occupied__EvghA","checkin":"StepSingleRoom_checkin__rt7O1","checkout":"StepSingleRoom_checkout__xS3bK"};